import React from "react";

interface IconesNovosProps {
  cor: string;
  active: boolean;
  type:
    | "house"
    | "atention"
    | "info"
    | "user"
    | "share"
    | "cart"
    | "x"
    | "back"
    | "foward"
    | "x_small"
    | "filter_small"
    | "order_small"
    | "options"
    | "filter"
    | "map"
    | "chat"
    | "internet"
    | "ask_price"
    | "cupom"
    | "list"
    | "orders"
    | "search"
    | "heart_small"
    | "plane"
    | "menu"
    | "heart"
    | "checkIn"
    | "location"
    | "note"
    | "groupChat"
    | "check"
    | "close"
    | "down"
    | "close_product"
    | `exit`
    | "pen"
    | "foward_circled"
    | "add_cart"
    | "remove_cart"
    | "remove"
    | "add_product"
    | "add_product_cart"
    | "remove_product_cart"
    | "remove_product"
    | "add"
    | "add_small"
    | "remove_small"
    | "remove_product_cart_small"
    | "add_product_cart_small"
    | "add_cart_small"
    | "remove_cart_small"
    | `minus`
    | `info_small`
    | `list_small`
    | `down_small`
    | `foward_small`
    | `cart_small`
    | `exit_small`
    | "trash_can";
  action: (e?: any) => void;
}

const IconesNovos: React.FC<IconesNovosProps> = ({
  cor,
  active,
  type,
  action,
}) => {
  const renderIcon = () => {
    switch (type) {
      case "house":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="26"
            viewBox="0 0 25 26"
            fill="none"
            style={{ opacity: active ? 1 : 0.5 }}
            onClick={action}
          >
            <path
              d="M24.9894 12.7216C24.9894 13.6016 24.3394 14.2866 23.5994 14.2866H22.2094L22.2394 22.1064C22.2394 22.2364 22.2295 22.3714 22.2194 22.5014V23.2914C22.2194 24.3714 21.4445 25.2463 20.4845 25.2463H19.7895C19.7395 25.2463 19.6945 25.2463 19.6445 25.2463C19.5845 25.2463 19.5245 25.2463 19.4645 25.2463H18.0546H17.0146C16.0546 25.2463 15.2796 24.3714 15.2796 23.2914V18.9965C15.2796 18.1315 14.6596 17.4365 13.8897 17.4365H11.1097C10.3397 17.4365 9.71976 18.1365 9.71976 18.9965V23.2914C9.71976 24.3714 8.94478 25.2463 7.9848 25.2463H5.55987C5.49487 25.2463 5.42986 25.2463 5.36486 25.2363C5.31487 25.2363 5.25987 25.2463 5.20987 25.2463H4.51489C3.55491 25.2463 2.77993 24.3714 2.77993 23.2914V17.8215C2.77993 17.7765 2.77993 17.7265 2.77993 17.6865V14.2816H1.38996C0.609984 14.2816 0 13.5966 0 12.7166C0 12.2767 0.130002 11.8867 0.434994 11.5467L11.5597 0.641943C11.8647 0.301951 12.2097 0.251953 12.5147 0.251953C12.8197 0.251953 13.1647 0.351951 13.4247 0.591945L24.5144 11.5517C24.8594 11.8917 25.0344 12.2817 24.9944 12.7216H24.9894Z"
              fill={cor}
            />
          </svg>
        );
      case "atention":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="26"
            viewBox="0 0 27 26"
            fill="none"
            style={{ opacity: active ? 1 : 0.5 }}
            onClick={action}
          >
            <path
              d="M0 22.0623C0 21.5834 0 21.1045 0 20.6256C0.718735 19.2571 1.4174 17.876 2.1635 16.5199C4.75934 11.8008 7.37707 7.09428 9.97291 2.37696C10.7372 0.988668 11.9193 0.246094 13.4991 0.246094C15.0788 0.246094 16.2755 0.981493 17.0253 2.37875C17.3919 3.06393 17.7896 3.73296 18.1636 4.41635C21.1097 9.81884 24.0539 15.2213 27 20.6256V22.0623C26.3159 24.0802 24.977 25.2461 22.735 25.2461C16.5783 25.2443 10.4235 25.2461 4.26681 25.2443C2.58854 25.2443 1.266 24.604 0.454226 23.1081C0.271806 22.7744 0.149585 22.4103 0 22.0623ZM15.1208 12.0143C15.1208 10.8179 15.1336 9.62334 15.1172 8.42697C15.1007 7.27364 14.4513 6.5508 13.4772 6.56515C12.5341 6.5777 11.8901 7.27723 11.8828 8.38033C11.8646 10.8018 11.8646 13.2214 11.8828 15.6428C11.892 16.7621 12.5177 17.4401 13.4754 17.4527C14.4696 17.467 15.0989 16.7746 15.1172 15.5998C15.1354 14.4052 15.1208 13.2089 15.1208 12.0125V12.0143ZM13.5337 22.118C14.3838 22.1018 15.1026 21.4005 15.108 20.5826C15.1135 19.7432 14.3346 19.0024 13.4644 19.0203C12.6289 19.0382 11.8974 19.7539 11.8901 20.5629C11.881 21.413 12.6472 22.1359 13.5356 22.1197L13.5337 22.118Z"
              fill={cor}
            />
          </svg>
        );
      case "info":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="26"
            viewBox="0 0 25 26"
            fill="none"
            style={{ opacity: active ? 1 : 0.5 }}
            onClick={action}
          >
            <path
              d="M12.5 25.2411C19.4 25.2411 25 19.6461 25 12.7411C25 5.83609 19.4 0.246094 12.5 0.246094C5.6 0.246094 0 5.84109 0 12.7461C0 19.6511 5.595 25.2461 12.5 25.2461V25.2411ZM10.545 16.6511H11.715V13.5261H10.545C9.895 13.5261 9.375 13.0061 9.375 12.3561C9.375 11.7061 9.895 11.1861 10.545 11.1861H12.89C13.54 11.1861 14.06 11.7061 14.06 12.3561V16.6511H14.45C15.1 16.6511 15.62 17.1711 15.62 17.8211C15.62 18.4711 15.1 18.9911 14.45 18.9911H10.545C9.895 18.9911 9.375 18.4711 9.375 17.8211C9.375 17.1711 9.895 16.6511 10.545 16.6511ZM12.5 6.49609C13.365 6.49609 14.06 7.19609 14.06 8.05609C14.06 8.91609 13.36 9.61609 12.5 9.61609C11.64 9.61609 10.94 8.91609 10.94 8.05609C10.94 7.19609 11.64 6.49609 12.5 6.49609Z"
              fill={cor}
            />
          </svg>
        );
      case "trash_can":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="26"
            viewBox="0 0 25 26"
            fill="none"
            style={{ opacity: active ? 1 : 0.5 }}
            onClick={action}
          >
            <path d="M3 6H5H22" stroke={cor} strokeWidth="2" />
            <path
              d="M8 6V4C8 3.44772 8.44772 3 9 3H16C16.5523 3 17 3.44772 17 4V6M19 6V22C19 22.5523 18.5523 23 18 23H7C6.44772 23 6 22.5523 6 22V6H19Z"
              stroke={cor}
              strokeWidth="2"
            />
            <path d="M10 10V18" stroke={cor} strokeWidth="2" />
            <path d="M14 10V18" stroke={cor} strokeWidth="2" />
          </svg>
        );
      case "info_small":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 25 26"
            fill="none"
            style={{ opacity: active ? 1 : 0.5 }}
            onClick={action}
          >
            <path
              d="M12.5 25.2411C19.4 25.2411 25 19.6461 25 12.7411C25 5.83609 19.4 0.246094 12.5 0.246094C5.6 0.246094 0 5.84109 0 12.7461C0 19.6511 5.595 25.2461 12.5 25.2461V25.2411ZM10.545 16.6511H11.715V13.5261H10.545C9.895 13.5261 9.375 13.0061 9.375 12.3561C9.375 11.7061 9.895 11.1861 10.545 11.1861H12.89C13.54 11.1861 14.06 11.7061 14.06 12.3561V16.6511H14.45C15.1 16.6511 15.62 17.1711 15.62 17.8211C15.62 18.4711 15.1 18.9911 14.45 18.9911H10.545C9.895 18.9911 9.375 18.4711 9.375 17.8211C9.375 17.1711 9.895 16.6511 10.545 16.6511ZM12.5 6.49609C13.365 6.49609 14.06 7.19609 14.06 8.05609C14.06 8.91609 13.36 9.61609 12.5 9.61609C11.64 9.61609 10.94 8.91609 10.94 8.05609C10.94 7.19609 11.64 6.49609 12.5 6.49609Z"
              fill={cor}
            />
          </svg>
        );
      case "user":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="26"
            viewBox="0 0 25 26"
            fill="none"
            style={{ opacity: active ? 1 : 0.5 }}
            onClick={action}
          >
            <path
              d="M12.2935 3.48691C9.36742 3.50046 7.05098 5.80336 7.0442 8.7023C7.03743 11.6487 9.38436 14.0193 12.307 14.0193C15.2771 14.0193 17.58 11.7096 17.5732 8.73617C17.5664 5.73901 15.2838 3.46998 12.2935 3.48691Z"
              fill={cor}
            />
            <path
              d="M12.5 0.246094C5.60824 0.246094 0 5.85433 0 12.7461C0 19.6379 5.60824 25.2461 12.5 25.2461C19.3918 25.2461 25 19.6379 25 12.7461C25 5.85433 19.3918 0.246094 12.5 0.246094ZM20.4552 20.1086C20.3908 19.5634 20.1063 19.0486 19.7067 18.4898C19.4561 18.1342 19.1479 17.8159 18.8194 17.5788C15.3177 15.0287 11.65 14.6257 7.82986 16.3393C6.63099 16.8778 5.49309 17.5483 4.67692 18.8251C4.46356 19.1603 4.32132 19.4685 4.23666 19.7632C2.62801 17.87 1.65267 15.4215 1.65267 12.7461C1.65267 6.76533 6.51924 1.89876 12.5 1.89876C18.4808 1.89876 23.3473 6.76533 23.3473 12.7461C23.3473 15.5875 22.2501 18.1715 20.4552 20.1086Z"
              fill={cor}
            />
          </svg>
        );
      case "share":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="26"
            viewBox="0 0 25 26"
            fill="none"
            style={{ opacity: active ? 1 : 0.5 }}
            onClick={action}
          >
            <path
              d="M19.6444 10.9628C22.6 10.9628 25 8.56276 25 5.6072C25 2.65165 22.6 0.246094 19.6444 0.246094C16.6889 0.246094 14.2889 2.64609 14.2889 5.60165C14.2889 5.82387 14.3 6.04609 14.3278 6.26832L9.07778 8.89054C8.11667 7.9572 6.80556 7.39054 5.36111 7.39054C2.4 7.39054 0 9.79054 0 12.7461C0 15.7016 2.4 18.1017 5.35556 18.1017C6.8 18.1017 8.11111 17.535 9.07222 16.6017L14.3222 19.2239C14.2944 19.4405 14.2833 19.6572 14.2833 19.8905C14.2833 22.8461 16.6833 25.2461 19.6389 25.2461C22.5944 25.2461 24.9944 22.8461 24.9944 19.8905C24.9944 16.935 22.5944 14.535 19.6389 14.535C18.1944 14.535 16.8833 15.1017 15.9222 16.035L10.6722 13.4128C10.7 13.1961 10.7111 12.9794 10.7111 12.7461C10.7111 12.5128 10.7 12.3016 10.6722 12.0794L15.9222 9.4572C16.8833 10.3905 18.1944 10.9572 19.6389 10.9572L19.6444 10.9628Z"
              fill={cor}
            />
          </svg>
        );
      case "cart":
        return (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              style={{ opacity: active ? 1 : 0.5 }}
              onClick={action}
            >
              <path
                d="M8.9501 16.0127H23.062V19.1621C22.7071 19.1871 22.3622 19.227 22.0173 19.227C17.5882 19.227 13.1542 19.232 8.72514 19.227C5.77079 19.227 4.40109 17.0125 6.00075 14.5481C7.08051 12.8834 7.11549 11.5237 6.11571 9.83909C5.07094 8.06947 4.28111 6.14489 3.4313 4.2653C3.16136 3.66043 2.83143 3.37549 2.15158 3.45547C1.65669 3.51546 1.1468 3.46547 0.501942 3.46547C0.501942 2.51068 0.471943 1.62087 0.526931 0.741064C0.536929 0.571101 0.896847 0.29616 1.1018 0.286163C2.26655 0.241172 3.4363 0.221177 4.60104 0.29616C4.88098 0.316156 5.2909 0.676078 5.37088 0.956017C5.78579 2.4257 6.71558 2.71563 8.16527 2.68564C13.2242 2.58566 18.2831 2.64565 23.342 2.64565C25.2966 2.64565 25.9864 3.8054 25.0466 5.52002C23.7519 7.87951 22.4222 10.219 21.1525 12.5885C20.4826 13.8382 19.4828 14.3881 18.0931 14.3781C15.6986 14.3631 13.3042 14.3781 10.9097 14.3781C9.97655 14.3781 9.31836 14.9213 8.93511 16.0077L8.9501 16.0127Z"
                fill={cor}
              />
              <path
                d="M5.37091 22.4214C5.38091 20.8317 6.56066 19.667 8.16032 19.667C9.76997 19.667 10.9597 20.9017 10.9297 22.5364C10.8997 24.101 9.68498 25.2608 8.09032 25.2458C6.52066 25.2258 5.36092 24.021 5.37091 22.4214Z"
                fill={cor}
              />
              <path
                d="M20.2526 25.2457C18.708 25.2457 17.4583 23.996 17.4533 22.4613C17.4483 20.9267 18.693 19.6819 20.2426 19.6719C21.8223 19.6619 23.122 20.9517 23.097 22.5013C23.077 24.016 21.7923 25.2507 20.2526 25.2457Z"
                fill={cor}
              />
            </svg>
          </>
        );
      case "cart_small":
        return (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 26 26"
              fill="none"
              style={{ opacity: active ? 1 : 0.5 }}
              onClick={action}
            >
              <path
                d="M8.9501 16.0127H23.062V19.1621C22.7071 19.1871 22.3622 19.227 22.0173 19.227C17.5882 19.227 13.1542 19.232 8.72514 19.227C5.77079 19.227 4.40109 17.0125 6.00075 14.5481C7.08051 12.8834 7.11549 11.5237 6.11571 9.83909C5.07094 8.06947 4.28111 6.14489 3.4313 4.2653C3.16136 3.66043 2.83143 3.37549 2.15158 3.45547C1.65669 3.51546 1.1468 3.46547 0.501942 3.46547C0.501942 2.51068 0.471943 1.62087 0.526931 0.741064C0.536929 0.571101 0.896847 0.29616 1.1018 0.286163C2.26655 0.241172 3.4363 0.221177 4.60104 0.29616C4.88098 0.316156 5.2909 0.676078 5.37088 0.956017C5.78579 2.4257 6.71558 2.71563 8.16527 2.68564C13.2242 2.58566 18.2831 2.64565 23.342 2.64565C25.2966 2.64565 25.9864 3.8054 25.0466 5.52002C23.7519 7.87951 22.4222 10.219 21.1525 12.5885C20.4826 13.8382 19.4828 14.3881 18.0931 14.3781C15.6986 14.3631 13.3042 14.3781 10.9097 14.3781C9.97655 14.3781 9.31836 14.9213 8.93511 16.0077L8.9501 16.0127Z"
                fill={cor}
              />
              <path
                d="M5.37091 22.4214C5.38091 20.8317 6.56066 19.667 8.16032 19.667C9.76997 19.667 10.9597 20.9017 10.9297 22.5364C10.8997 24.101 9.68498 25.2608 8.09032 25.2458C6.52066 25.2258 5.36092 24.021 5.37091 22.4214Z"
                fill={cor}
              />
              <path
                d="M20.2526 25.2457C18.708 25.2457 17.4583 23.996 17.4533 22.4613C17.4483 20.9267 18.693 19.6819 20.2426 19.6719C21.8223 19.6619 23.122 20.9517 23.097 22.5013C23.077 24.016 21.7923 25.2507 20.2526 25.2457Z"
                fill={cor}
              />
            </svg>
          </>
        );
      case "x":
        return (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              style={{ opacity: active ? 1 : 0.5 }}
              onClick={action}
            >
              <rect
                x="3.59387"
                y="20.2461"
                width="4.42875"
                height="23.2509"
                rx="2.21438"
                transform="rotate(-135 3.59387 20.2461)"
                fill={cor}
              />
              <rect
                x="0.593872"
                y="3.24609"
                width="4.42875"
                height="23.2509"
                rx="2.21438"
                transform="rotate(-45 0.593872 3.24609)"
                fill={cor}
              />
            </svg>
          </>
        );
      case "x_small":
        return (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              viewBox="0 0 21 21"
              fill="none"
              style={{ opacity: active ? 1 : 0.5 }}
              onClick={action}
            >
              <rect
                x="3.59387"
                y="20.2461"
                width="4.42875"
                height="23.2509"
                rx="2.21438"
                transform="rotate(-135 3.59387 20.2461)"
                fill={cor}
              />
              <rect
                x="0.593872"
                y="3.24609"
                width="4.42875"
                height="23.2509"
                rx="2.21438"
                transform="rotate(-45 0.593872 3.24609)"
                fill={cor}
              />
            </svg>
          </>
        );
      case "back":
        return (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="21"
              viewBox="0 0 12 21"
              fill="none"
              style={{ opacity: active ? 1 : 0.5 }}
              onClick={action}
            >
              <path
                d="M12.7902 16.862C10.0597 14.2869 7.33113 11.7138 4.60059 9.13873L4.60059 12.3542C7.33113 9.77918 10.0597 7.20602 12.7902 4.63096C14.9883 2.55804 11.5786 -0.657463 9.38055 1.41546C6.65001 3.99052 3.92147 6.56368 1.19092 9.13873C0.270697 10.0066 0.268687 11.4845 1.19092 12.3542C3.92147 14.9293 6.65 17.5024 9.38055 20.0775C11.5766 22.1485 14.9883 18.9349 12.7902 16.862Z"
                fill={cor}
              />
            </svg>
          </>
        );
      case "foward":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="21"
            viewBox="0 0 14 21"
            fill="none"
            style={{ opacity: active ? 1 : 0.5 }}
            onClick={action}
          >
            <path
              d="M1.20979 4.63019C3.94033 7.20524 6.66887 9.7784 9.39941 12.3535V9.13796C6.66887 11.713 3.94033 14.2862 1.20979 16.8612C-0.988312 18.9342 2.42135 22.1497 4.61945 20.0767C7.35 17.5017 10.0785 14.9285 12.8091 12.3535C13.7293 11.4856 13.7313 10.0077 12.8091 9.13796C10.0785 6.5629 7.35 3.98974 4.61945 1.41469C2.42336 -0.656343 -0.988312 2.55726 1.20979 4.63019Z"
              fill={cor}
            />
          </svg>
        );

      case "foward_small":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="18"
            viewBox="0 0 14 21"
            fill="none"
            style={{ opacity: active ? 1 : 0.5 }}
            onClick={action}
          >
            <path
              d="M1.20979 4.63019C3.94033 7.20524 6.66887 9.7784 9.39941 12.3535V9.13796C6.66887 11.713 3.94033 14.2862 1.20979 16.8612C-0.988312 18.9342 2.42135 22.1497 4.61945 20.0767C7.35 17.5017 10.0785 14.9285 12.8091 12.3535C13.7293 11.4856 13.7313 10.0077 12.8091 9.13796C10.0785 6.5629 7.35 3.98974 4.61945 1.41469C2.42336 -0.656343 -0.988312 2.55726 1.20979 4.63019Z"
              fill={cor}
            />
          </svg>
        );
      case "down":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="21"
            viewBox="0 0 14 21"
            fill="none"
            style={{ opacity: active ? 1 : 0.5, transform: "rotate(90deg)" }}
            onClick={action}
          >
            <path
              d="M1.20979 4.63019C3.94033 7.20524 6.66887 9.7784 9.39941 12.3535V9.13796C6.66887 11.713 3.94033 14.2862 1.20979 16.8612C-0.988312 18.9342 2.42135 22.1497 4.61945 20.0767C7.35 17.5017 10.0785 14.9285 12.8091 12.3535C13.7293 11.4856 13.7313 10.0077 12.8091 9.13796C10.0785 6.5629 7.35 3.98974 4.61945 1.41469C2.42336 -0.656343 -0.988312 2.55726 1.20979 4.63019Z"
              fill={cor}
            />
          </svg>
        );

      case "down_small":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="18"
            viewBox="0 0 14 21"
            fill="none"
            style={{ opacity: active ? 1 : 0.5, transform: "rotate(90deg)" }}
            onClick={action}
          >
            <path
              d="M1.20979 4.63019C3.94033 7.20524 6.66887 9.7784 9.39941 12.3535V9.13796C6.66887 11.713 3.94033 14.2862 1.20979 16.8612C-0.988312 18.9342 2.42135 22.1497 4.61945 20.0767C7.35 17.5017 10.0785 14.9285 12.8091 12.3535C13.7293 11.4856 13.7313 10.0077 12.8091 9.13796C10.0785 6.5629 7.35 3.98974 4.61945 1.41469C2.42336 -0.656343 -0.988312 2.55726 1.20979 4.63019Z"
              fill={cor}
            />
          </svg>
        );
      case "options":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="26"
            viewBox="0 0 8 26"
            fill="none"
            style={{ opacity: active ? 1 : 0.5 }}
            onClick={action}
          >
            <circle cx="3.98901" cy="22.1211" r="3.125" fill={cor} />
            <circle cx="3.98901" cy="22.1211" r="3.125" fill={cor} />
            <circle cx="3.98901" cy="22.1211" r="3.125" fill={cor} />
            <circle cx="3.98901" cy="22.1211" r="3.125" fill={cor} />
            <circle cx="3.98901" cy="22.1211" r="3.125" fill={cor} />
            <circle cx="3.98901" cy="12.7461" r="3.125" fill={cor} />
            <circle cx="3.98901" cy="12.7461" r="3.125" fill={cor} />
            <circle cx="3.98901" cy="12.7461" r="3.125" fill={cor} />
            <circle cx="3.98901" cy="12.7461" r="3.125" fill={cor} />
            <circle cx="3.98901" cy="12.7461" r="3.125" fill={cor} />
            <circle cx="3.98901" cy="3.37109" r="3.125" fill={cor} />
            <circle cx="3.98901" cy="3.37109" r="3.125" fill={cor} />
            <circle cx="3.98901" cy="3.37109" r="3.125" fill={cor} />
            <circle cx="3.98901" cy="3.37109" r="3.125" fill={cor} />
            <circle cx="3.98901" cy="3.37109" r="3.125" fill={cor} />
          </svg>
        );
      case "filter":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            style={{ opacity: active ? 1 : 0.5 }}
            onClick={action}
          >
            <path
              d="M1.04845 1.52617C1.36847 0.746124 2.05352 0.246094 2.81357 0.246094H23.91C24.665 0.246094 25.3501 0.741124 25.6751 1.52617C26.0002 2.31121 25.9001 3.22626 25.4201 3.8963L16.4895 16.367V23.4624C16.4895 24.1374 16.1595 24.7575 15.6244 25.0575C15.0894 25.3575 14.4644 25.2975 13.9893 24.8925L10.8641 22.2123C10.4691 21.8773 10.2391 21.3473 10.2391 20.7822V16.367L1.30346 3.8863C0.828424 3.22126 0.728417 2.29621 1.05344 1.52117L1.04845 1.52617Z"
              fill={cor}
            />
          </svg>
        );

      case "chat":
        return (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              style={{ opacity: active ? 1 : 0.5 }}
              onClick={action}
            >
              <path
                d="M22.6525 21.5553C22.6525 21.4494 22.597 21.2881 22.6525 21.2326C24.3669 19.6291 25.4358 17.3802 25.4358 14.9145C25.4358 9.88221 21.0439 5.8685 15.5881 5.91893C10.1272 5.91893 5.74036 9.93262 5.74036 14.9649C5.74036 19.9972 10.1323 24.0109 15.5881 23.9605C16.6571 23.9605 17.6756 23.7991 18.6942 23.5319C18.906 23.4764 19.0673 23.5874 19.2287 23.6933C20.7263 24.6564 22.3348 25.2463 24.1551 25.2463C24.8509 25.2463 24.5837 24.7622 24.4778 24.6059C23.7265 23.6428 22.9802 22.6798 22.6575 21.5553H22.6525ZM10.1272 16.8962C9.05822 16.8962 8.14556 15.9331 8.14556 14.7532C8.14556 13.5732 9.05318 12.6102 10.1272 12.6102C11.2012 12.6102 12.1089 13.5732 12.1089 14.7532C12.1089 15.9331 11.2012 16.8962 10.1272 16.8962ZM15.7999 16.8962C14.7309 16.8962 13.8182 15.9331 13.8182 14.7532C13.8182 13.5732 14.7258 12.6102 15.7999 12.6102C16.8739 12.6102 17.7815 13.5732 17.7815 14.7532C17.7815 15.9331 16.8739 16.8962 15.7999 16.8962ZM19.4405 14.7027C19.4405 13.5228 20.3481 12.5597 21.4221 12.5597C22.4961 12.5597 23.4038 13.5228 23.4038 14.7027C23.4038 15.8826 22.4961 16.8457 21.4221 16.8457C20.3531 16.9012 19.4405 15.8826 19.4405 14.7027Z"
                fill={cor}
              />
              <path
                d="M7.88331 7.3155C13.3492 3.12529 17.3529 5.41453 17.0352 4.79432C15.588 2.0664 12.5929 0.246094 9.11365 0.246094C4.18726 0.246094 0.229004 3.88669 0.229004 8.38448C0.229004 10.6334 1.19209 12.615 2.74514 14.1126C2.8006 14.1681 2.8006 14.3244 2.74514 14.3799C2.47789 15.3984 1.78205 16.2556 1.03074 17.1077C0.924848 17.2136 0.708019 17.6977 1.35344 17.6977C2.21064 17.6977 3.50654 17.1178 4.56039 16.6035C5.01925 16.3766 3.26955 10.8603 7.88836 7.3155H7.88331Z"
                fill={cor}
              />
            </svg>
          </>
        );
      case "internet":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            style={{ opacity: active ? 1 : 0.5 }}
            onClick={action}
          >
            <path
              d="M13.281 0.246094C6.37635 0.246094 0.781006 5.84144 0.781006 12.7461C0.781006 15.5941 1.73501 18.2211 3.34088 20.3222C3.32689 22.177 2.45122 23.0331 1.10833 23.8752C0.736243 24.1102 0.93208 24.7621 1.36852 24.8041C3.63463 25.0279 4.98311 24.7257 7.0366 23.7829C7.10654 23.7521 7.18768 23.727 7.2744 23.7102C9.05652 24.6894 11.1044 25.2461 13.281 25.2461C20.1857 25.2461 25.781 19.6507 25.781 12.7461C25.781 5.84144 20.1857 0.246094 13.281 0.246094ZM22.684 8.72304C21.3047 8.72304 19.9423 8.73703 18.5826 8.69786C18.4539 8.69506 18.2776 8.36774 18.2245 8.1663C17.9839 7.28784 17.8412 6.37859 17.5503 5.51971C17.2593 4.66082 16.8313 3.8495 16.4592 3.01299C18.8484 3.483 22.0881 6.40377 22.6868 8.72304H22.684ZM17.1642 15.3983H9.42302V10.0995C10.7491 10.0995 11.9941 10.0995 13.2362 10.0995C14.3805 10.0995 15.5247 10.0883 16.6662 10.1135C16.834 10.1163 17.139 10.3065 17.1418 10.4128C17.1726 12.0663 17.1642 13.7225 17.1642 15.3983ZM15.2142 3.73759C16.1906 5.22036 16.627 6.89896 16.9348 8.68947H9.63564C9.93219 6.90176 10.377 5.20637 11.3674 3.71241C12.4753 2.0394 14.1035 2.05059 15.2142 3.73759ZM10.198 3.0074C9.15164 4.66642 8.62288 6.47931 8.30115 8.36774C8.27877 8.50482 8.04376 8.70625 7.90388 8.70905C6.58058 8.73423 5.25448 8.72584 3.91999 8.72584C4.42917 6.57723 7.5178 3.49699 10.198 3.0074ZM3.26534 15.0822C2.90444 13.5434 2.88486 11.9991 3.25974 10.4604C3.29332 10.3177 3.51153 10.1163 3.64582 10.1163C5.09502 10.0911 6.54421 10.0995 7.9962 10.0995V15.4151C6.54141 15.4151 5.07543 15.4235 3.60666 15.4011C3.48636 15.4011 3.29611 15.2108 3.26534 15.0794V15.0822ZM3.7885 16.7663C5.24609 16.7663 6.57499 16.7524 7.89828 16.7859C8.05216 16.7887 8.28157 17.0517 8.33192 17.2336C8.57812 18.1316 8.71521 19.066 9.01176 19.9445C9.30831 20.8202 9.74755 21.6511 10.1448 22.5491C7.22405 21.5755 5.15657 19.6759 3.78571 16.7636L3.7885 16.7663ZM11.4401 21.8917C10.6204 20.7418 9.96017 18.859 9.66082 16.8027H16.9208C16.6186 18.652 16.1626 20.4201 15.0771 21.9504C14.0364 23.4164 12.4921 23.3717 11.4373 21.8917H11.4401ZM16.4256 22.4988C17.4048 20.8621 17.9195 19.0828 18.2469 17.2308C18.2776 17.0545 18.5238 16.7887 18.6777 16.7859C20.001 16.7496 21.3271 16.7663 22.7875 16.7663C21.453 19.6591 19.3715 21.5364 16.4284 22.5016L16.4256 22.4988ZM22.9582 15.4011C21.4894 15.4235 20.0234 15.4151 18.5686 15.4151V10.0967H19.1841C20.3871 10.0967 21.5901 10.1051 22.7959 10.0911C23.1176 10.0883 23.2659 10.1722 23.3386 10.5163C23.666 12.0439 23.652 13.5658 23.2995 15.0822C23.2687 15.2136 23.0757 15.4011 22.9554 15.4011H22.9582Z"
              fill={cor}
            />
          </svg>
        );
      case "ask_price":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="26"
            viewBox="0 0 24 26"
            fill="none"
            style={{ opacity: active ? 1 : 0.5 }}
            onClick={action}
          >
            <path
              d="M20.6471 20.526C20.6171 20.406 20.6221 20.251 20.6621 20.106C22.7271 18.001 23.997 15.116 23.997 11.911C23.997 5.43106 18.8021 0.246094 12.3171 0.246094C5.84218 0.246094 0.652222 5.44606 0.652222 11.926C0.652222 18.406 5.84718 23.5909 12.3321 23.5909C13.6121 23.5909 14.8421 23.3809 15.9921 23.0059C16.2121 23.0159 16.4621 23.1009 16.6271 23.2109C18.3971 24.4259 20.3171 25.1809 22.4771 25.2459C22.6921 25.2509 22.9071 25.1459 23.1221 25.0909C23.0421 24.8659 23.0171 24.5909 22.8721 24.4159C21.9121 23.2409 21.0371 22.0159 20.6521 20.521L20.6471 20.526ZM13.7471 18.086C13.6221 18.096 13.5021 18.116 13.3171 18.136C13.3171 18.626 13.3071 19.066 13.3171 19.501C13.3271 19.931 13.1321 20.151 12.7021 20.156C11.3071 20.176 11.2921 20.201 11.3221 18.851C11.3221 18.631 11.3221 18.416 11.3221 18.251C10.6572 18.051 10.0072 17.946 9.44215 17.671C7.96716 16.951 8.16716 16.721 9.12215 15.851C9.26215 15.726 9.39716 15.591 9.52716 15.456C9.73716 15.231 12.4421 15.606 13.5521 15.601C13.9721 15.601 14.3271 15.146 14.3521 14.731C14.3771 14.311 14.0821 13.896 13.6071 13.751C12.6071 13.446 11.6021 13.166 10.6021 12.866C9.58716 12.561 8.74216 12.026 8.21217 11.071C7.03218 8.93603 8.47216 6.26105 10.9121 6.07105C11.0321 6.06105 11.1571 6.03605 11.3221 6.01105C11.3221 5.55606 11.3221 5.11606 11.3221 4.68106C11.3271 4.18107 11.4821 4.01107 11.9571 4.00607C13.2921 3.98607 13.3471 3.94607 13.3121 5.28606C13.3071 5.52106 13.3121 5.75106 13.3121 5.91106C13.9971 6.11605 14.6621 6.22605 15.2371 6.50605C16.5971 7.17605 16.5021 7.41604 15.5471 8.27104C15.4321 8.37604 15.3071 8.48104 15.2121 8.60104C14.9421 8.93603 14.6521 8.92103 14.2521 8.80604C13.6771 8.64104 13.0621 8.59104 12.4571 8.53104C12.0821 8.49104 11.7021 8.51604 11.3221 8.53104C10.7472 8.54604 10.3772 8.86604 10.3072 9.38603C10.2472 9.84103 10.5221 10.256 11.0321 10.411C12.0721 10.726 13.1121 11.031 14.1621 11.321C15.4871 11.686 16.3571 12.526 16.7171 13.841C17.2721 15.871 15.8371 17.891 13.7421 18.086H13.7471Z"
              fill={cor}
            />
          </svg>
        );
      case "cupom":
        return (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              style={{ opacity: active ? 1 : 0.5 }}
              onClick={action}
            >
              <path
                d="M18.3361 6.355C22.0279 6.36472 25.0882 9.44446 25.0687 13.1265C25.0493 16.8232 21.9647 19.8884 18.2923 19.8689C14.6005 19.8447 11.5305 16.7552 11.5597 13.0828C11.5888 9.3716 14.6394 6.34529 18.3361 6.355ZM17.5491 9.46389C16.3056 9.7845 15.6935 10.4597 15.6498 11.5187C15.6109 12.4611 16.291 13.2626 17.418 13.6075C17.9766 13.7775 18.5498 13.9135 19.0841 14.1369C19.2639 14.2147 19.4679 14.5207 19.4533 14.7053C19.4387 14.8996 19.1861 15.2105 19.0161 15.2299C18.4915 15.2833 17.8989 15.3562 17.4374 15.1716C16.8448 14.9336 16.5679 15.1959 16.2376 15.5456C15.9607 15.8371 15.9558 16.1043 16.325 16.284C16.7136 16.4735 17.1216 16.6095 17.5394 16.7795C17.656 17.683 17.7288 17.7899 18.2632 17.8044C18.8461 17.819 18.8898 17.7704 19.0793 16.8669C19.5602 16.59 20.0557 16.4346 20.3665 16.0994C21.4692 14.919 20.9738 13.1848 19.429 12.6845C18.7975 12.4805 18.1466 12.3299 17.5297 12.0822C17.35 12.0093 17.1459 11.6935 17.1605 11.5041C17.1751 11.3146 17.4374 11.0086 17.6123 10.994C18.1369 10.9455 18.7101 10.8969 19.1959 11.0572C19.7448 11.2418 20.0508 11.0669 20.3714 10.6977C20.6677 10.3577 20.6629 10.1391 20.2645 9.92537C19.8905 9.72135 19.4727 9.58533 19.0696 9.41531C19.0064 8.5798 18.885 8.42436 18.3021 8.42436C17.7289 8.42436 17.6171 8.57009 17.5394 9.46875L17.5491 9.46389Z"
                fill={cor}
              />
              <path
                d="M18.0639 21.239C15.6206 21.239 13.4346 20.1558 11.9433 18.4507C11.0252 18.4507 10.1071 18.4507 9.18904 18.4507C7.41601 18.4507 5.64298 18.441 3.86995 18.4556C3.32103 18.4605 3.04414 18.3099 3.03928 17.6978C3.03928 17.0858 3.24817 16.8623 3.86995 16.8672C6.20161 16.8817 8.53327 16.8672 10.8649 16.8672C10.3889 15.9588 10.078 14.9484 9.97598 13.8749C9.69424 13.8749 9.4125 13.8749 9.13076 13.8749C7.37715 13.8749 5.62354 13.8651 3.87479 13.8797C3.3356 13.8797 3.04414 13.7486 3.03928 13.1268C3.03928 12.4953 3.28702 12.3107 3.88936 12.3156C5.91986 12.3253 7.95035 12.3156 9.98084 12.3156C10.0829 11.242 10.3986 10.2316 10.8746 9.32325C10.2723 9.32325 9.66995 9.32325 9.0676 9.32325C7.33829 9.32325 5.60897 9.30868 3.87965 9.33297C3.27245 9.34268 3.03443 9.12895 3.04414 8.50717C3.05386 7.89997 3.33074 7.74453 3.87965 7.74938C6.57564 7.7591 9.26676 7.75424 11.9627 7.74938C13.454 6.04921 15.6351 4.97082 18.0737 4.97082C18.1368 4.97082 18.2 4.98053 18.2583 4.98053C18.2583 3.98957 18.2582 3.00348 18.2534 2.01252C18.2534 1.67734 18.0057 1.16243 17.7433 1.05557C17.5005 0.958413 17.005 1.22072 16.7572 1.46361C16.2083 1.99795 15.742 2.61972 15.2222 3.23664C14.4256 2.58086 13.6969 1.97851 12.9586 1.38588C12.2445 0.807823 12.0939 0.812685 11.3701 1.40532C10.6269 2.01252 9.88368 2.62458 9.14046 3.2415C8.39239 2.62458 7.69289 2.05623 7.00311 1.48303C6.15788 0.783533 6.06074 0.783536 5.19122 1.49275C4.48201 2.07081 3.7825 2.64887 3.05871 3.2415C2.50494 2.59058 2.04833 1.97852 1.51399 1.44903C1.28082 1.21587 0.785348 0.938983 0.591043 1.04099C0.323873 1.17701 0.0955646 1.65305 0.090707 1.98337C0.0615612 9.40097 0.0615612 16.8137 0.090707 24.2313C0.090707 24.5616 0.32873 25.0377 0.591043 25.1737C0.785348 25.2709 1.28082 24.994 1.51399 24.7608C2.05804 24.2168 2.52923 23.595 3.05871 22.9683C3.80679 23.5804 4.49658 24.1536 5.19122 24.7171C6.06074 25.4214 6.15788 25.4215 7.00311 24.722C7.71232 24.139 8.42154 23.5561 9.14533 22.9635C9.92741 23.6096 10.6949 24.207 11.4236 24.8483C11.9385 25.3 12.3805 25.3437 12.9149 24.8677C13.6386 24.2265 14.411 23.6338 15.2271 22.9635C15.7614 23.595 16.218 24.207 16.7572 24.7365C17.005 24.9794 17.5005 25.2466 17.7433 25.1494C18.0057 25.0426 18.2534 24.5276 18.2534 24.1925C18.2534 23.2015 18.2534 22.2154 18.2583 21.2245C18.1951 21.2245 18.1368 21.2342 18.0737 21.2342L18.0639 21.239Z"
                fill={cor}
              />
            </svg>
          </>
        );
      case "list":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            style={{ opacity: active ? 1 : 0.5 }}
            onClick={action}
          >
            <path
              d="M22.6366 0.246094H3.92538C2.19572 0.246094 0.781006 1.66082 0.781006 3.39047V22.1017C0.781006 23.8314 2.19572 25.2461 3.92538 25.2461H22.6366C24.3663 25.2461 25.781 23.8314 25.781 22.1017V3.39047C25.781 1.66082 24.3663 0.246094 22.6366 0.246094ZM7.03975 21.0669C5.07515 22.1467 3.08555 20.1521 4.16033 18.1925C4.3053 17.9326 4.52026 17.7126 4.78021 17.5726C6.74481 16.4928 8.73442 18.4874 7.65463 20.4471C7.50966 20.707 7.2947 20.927 7.03476 21.0669H7.03975ZM7.03975 14.4882C5.07515 15.568 3.08555 13.5734 4.16033 11.6138C4.3053 11.3539 4.52026 11.1339 4.78021 10.9939C6.74481 9.91416 8.73442 11.9088 7.65963 13.8684C7.51466 14.1283 7.2997 14.3483 7.03975 14.4882ZM7.03975 7.90956C5.07515 8.98935 3.08555 6.99475 4.16033 5.03514C4.3053 4.77519 4.52026 4.55523 4.78021 4.41526C6.74481 3.33547 8.73442 5.33008 7.65963 7.28968C7.51466 7.54963 7.2997 7.76959 7.03975 7.90956ZM22.2017 17.3077V21.3319H9.64923V17.3077H22.2017ZM22.2017 10.729V14.7532H9.64923V10.729H22.2017ZM22.2017 4.15031V8.17451H9.64923V4.15031H22.2017Z"
              fill={cor}
            />
          </svg>
        );
      case "list_small":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 26 26"
            fill="none"
            style={{ opacity: active ? 1 : 0.5 }}
            onClick={action}
          >
            <path
              d="M22.6366 0.246094H3.92538C2.19572 0.246094 0.781006 1.66082 0.781006 3.39047V22.1017C0.781006 23.8314 2.19572 25.2461 3.92538 25.2461H22.6366C24.3663 25.2461 25.781 23.8314 25.781 22.1017V3.39047C25.781 1.66082 24.3663 0.246094 22.6366 0.246094ZM7.03975 21.0669C5.07515 22.1467 3.08555 20.1521 4.16033 18.1925C4.3053 17.9326 4.52026 17.7126 4.78021 17.5726C6.74481 16.4928 8.73442 18.4874 7.65463 20.4471C7.50966 20.707 7.2947 20.927 7.03476 21.0669H7.03975ZM7.03975 14.4882C5.07515 15.568 3.08555 13.5734 4.16033 11.6138C4.3053 11.3539 4.52026 11.1339 4.78021 10.9939C6.74481 9.91416 8.73442 11.9088 7.65963 13.8684C7.51466 14.1283 7.2997 14.3483 7.03975 14.4882ZM7.03975 7.90956C5.07515 8.98935 3.08555 6.99475 4.16033 5.03514C4.3053 4.77519 4.52026 4.55523 4.78021 4.41526C6.74481 3.33547 8.73442 5.33008 7.65963 7.28968C7.51466 7.54963 7.2997 7.76959 7.03975 7.90956ZM22.2017 17.3077V21.3319H9.64923V17.3077H22.2017ZM22.2017 10.729V14.7532H9.64923V10.729H22.2017ZM22.2017 4.15031V8.17451H9.64923V4.15031H22.2017Z"
              fill={cor}
            />
          </svg>
        );
      case "orders":
        return (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              style={{ opacity: active ? 1 : 0.5 }}
              onClick={action}
            >
              <path
                d="M23.9863 0.250977C23.0015 0.250977 22.1967 1.28577 22.1967 2.55052V6.22978H25.7709V2.55052C25.7709 1.28577 24.9661 0.250977 23.9813 0.250977H23.9863Z"
                fill={cor}
              />
              <path
                d="M15.903 22.9465V20.577C15.903 20.577 15.903 20.567 15.903 20.562C15.913 20.562 0.781006 20.562 0.781006 20.562C0.781006 23.1365 2.51566 25.2461 4.63524 25.2461H16.9278C16.9278 25.2461 15.903 25.0411 15.903 22.9465Z"
                fill={cor}
              />
              <path
                d="M5.89502 4.93515V18.9873H17.1478V22.9466C17.1478 24.2113 18.0176 25.2461 19.0824 25.2461C20.1472 25.2461 21.017 24.2113 21.017 22.9466V18.5674V4.93015C21.017 4.93015 21.017 4.92016 21.017 4.91516V2.54563C21.017 0.451048 22.0418 0.246094 22.0418 0.246094H9.74924C7.62967 0.246094 5.89502 2.35567 5.89502 4.93015V4.93515ZM17.6477 15.743H9.60927C9.22435 15.743 8.90942 15.3681 8.90942 14.9132C8.90942 14.4583 9.22435 14.0833 9.60927 14.0833H17.6477C18.0326 14.0833 18.3475 14.4583 18.3475 14.9132C18.3475 15.3681 18.0326 15.743 17.6477 15.743ZM17.6477 10.844H9.60927C9.22435 10.844 8.90942 10.469 8.90942 10.0141C8.90942 9.55923 9.22435 9.1843 9.60927 9.1843H17.6477C18.0326 9.1843 18.3475 9.55923 18.3475 10.0141C18.3475 10.469 18.0326 10.844 17.6477 10.844ZM18.3475 5.10512C18.3475 5.56503 18.0326 5.93495 17.6477 5.93495H9.60927C9.22435 5.93495 8.90942 5.56003 8.90942 5.10512C8.90942 4.65021 9.22435 4.27529 9.60927 4.27529H17.6477C18.0326 4.27529 18.3475 4.65021 18.3475 5.10512Z"
                fill={cor}
              />
            </svg>
          </>
        );
      case "search":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="26"
            viewBox="0 0 25 26"
            fill="none"
            style={{ opacity: active ? 1 : 0.5 }}
            onClick={action}
          >
            <path
              d="M24.3859 23.1261C23.6882 23.9071 23.0979 24.5208 22.4538 25.2461C20.2535 22.9587 18.0532 20.6713 15.8528 18.3839C15.6918 18.2165 15.6381 17.9934 15.6381 17.7702C15.4771 16.487 15.3698 16.487 14.4038 17.1565C9.25176 20.8945 2.06037 18.0492 0.611365 11.6891C-0.515643 6.61219 2.70438 1.36792 7.53441 0.419488C12.6864 -0.584734 17.4091 2.87425 18.1605 8.17432C18.4825 10.6291 17.9458 12.8607 16.5505 14.9249C16.0138 15.7618 16.0675 15.9291 17.0871 16.0965C17.3555 16.1523 17.6775 16.2081 17.8922 16.3755C20.0388 18.6071 22.2392 20.8387 24.3859 23.1261ZM9.30542 16.0965C12.7401 16.0965 15.5845 13.1396 15.6381 9.56907C15.6918 5.9985 12.7938 2.98583 9.41276 2.98583C5.9244 2.93004 3.02638 5.94271 3.02638 9.51328C3.02638 13.0838 5.87073 16.0407 9.30542 16.0965Z"
              fill={cor}
            />
          </svg>
        );
      case "menu":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            style={{ opacity: active ? 1 : 0.5 }}
            onClick={action}
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M25.864 1.76125V3.2764C25.864 4.11319 24.8147 4.79155 23.5203 4.79155L3.20776 4.79155C1.91335 4.79155 0.864014 4.11319 0.864014 3.2764L0.864014 1.76124C0.864014 0.924449 1.91335 0.246094 3.20776 0.246094H23.5203C24.8147 0.246094 25.864 0.92445 25.864 1.76125ZM25.864 11.9885V13.5037C25.864 14.3405 24.8147 15.0188 23.5203 15.0188L3.20776 15.0188C1.91335 15.0188 0.864014 14.3405 0.864014 13.5037L0.864014 11.9885C0.864014 11.1517 1.91335 10.4734 3.20776 10.4734L23.5203 10.4734C24.8147 10.4734 25.864 11.1517 25.864 11.9885ZM25.864 23.7309V22.2158C25.864 21.379 24.8147 20.7006 23.5203 20.7006L3.20776 20.7006C1.91335 20.7006 0.864014 21.379 0.864014 22.2158L0.864014 23.7309C0.864014 24.5677 1.91335 25.2461 3.20776 25.2461L23.5203 25.2461C24.8147 25.2461 25.864 24.5677 25.864 23.7309Z"
              fill={cor}
            />
          </svg>
        );
      case "heart":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="26"
            viewBox="0 0 30 26"
            fill="none"
            style={{ opacity: active ? 1 : 0.5 }}
            onClick={action}
          >
            <path
              d="M3.10528 14.9946L13.4211 24.6262C13.848 25.0239 14.4153 25.2461 15.0001 25.2461C15.5849 25.2461 16.1521 25.0239 16.579 24.6262L26.8949 14.9946C28.6317 13.3805 29.6142 11.1115 29.6142 8.74308V8.40976C29.6142 4.42143 26.7311 1.01789 22.7954 0.357067C20.1931 -0.0756839 17.544 0.772271 15.6784 2.63778L14.9942 3.322L14.31 2.63778C12.4504 0.778119 9.80122 -0.0756839 7.19302 0.357067C3.25732 1.01204 0.374268 4.41558 0.374268 8.40976V8.74308C0.374268 11.1115 1.35673 13.3805 3.09358 14.9946H3.10528Z"
              fill={cor}
            />
          </svg>
        );
      case "heart_small":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 30 26"
            fill="none"
            scale={0.5}
            style={{ opacity: active ? 1 : 0.5 }}
            onClick={action}
          >
            <path
              d="M3.10528 14.9946L13.4211 24.6262C13.848 25.0239 14.4153 25.2461 15.0001 25.2461C15.5849 25.2461 16.1521 25.0239 16.579 24.6262L26.8949 14.9946C28.6317 13.3805 29.6142 11.1115 29.6142 8.74308V8.40976C29.6142 4.42143 26.7311 1.01789 22.7954 0.357067C20.1931 -0.0756839 17.544 0.772271 15.6784 2.63778L14.9942 3.322L14.31 2.63778C12.4504 0.778119 9.80122 -0.0756839 7.19302 0.357067C3.25732 1.01204 0.374268 4.41558 0.374268 8.40976V8.74308C0.374268 11.1115 1.35673 13.3805 3.09358 14.9946H3.10528Z"
              fill={cor}
            />
          </svg>
        );

      case "close_product":
        return (
          <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={action}
          >
            <circle cx="10" cy="10.5117" r="10" fill="#A6003A" />
            <rect
              width="3.26169"
              height="17.1239"
              rx="1.63085"
              transform="matrix(-0.714659 -0.699473 0.714659 -0.699473 4.99805 17.8457)"
              fill="white"
            />
            <rect
              width="3.26169"
              height="17.1239"
              rx="1.63085"
              transform="matrix(0.714659 -0.699473 0.714659 0.699473 2.76465 5.45996)"
              fill="white"
            />
          </svg>
        );

      case "foward_circled":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            onClick={action}
          >
            <circle cx="15" cy="15" r="15" fill="#221E1F" />
            <path
              d="M9.70979 8.8841C12.4403 11.4592 15.1689 14.0323 17.8994 16.6074V13.3919C15.1689 15.9669 12.4403 18.5401 9.70979 21.1151C7.51169 23.1881 10.9214 26.4036 13.1195 24.3306C15.85 21.7556 18.5785 19.1824 21.3091 16.6074C22.2293 15.7395 22.2313 14.2616 21.3091 13.3919C18.5785 10.8168 15.85 8.24365 13.1195 5.6686C10.9234 3.59756 7.51169 6.81117 9.70979 8.8841Z"
              fill="white"
            />
          </svg>
        );

      case "filter_small":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="15"
            viewBox="0 0 16 15"
            fill="none"
            onClick={action}
          >
            <path
              d="M1.30495 3.2025H3.36295V3.549C3.36295 4.17 3.86695 4.674 4.48795 4.674C5.10895 4.674 5.61295 4.17 5.61295 3.549V3.2025H14.574C15.0495 3.2025 15.4395 2.8125 15.4395 2.337C15.4395 1.8615 15.0495 1.4715 14.574 1.4715H5.61295V1.125C5.61295 0.504 5.10895 0 4.48795 0C3.86695 0 3.36295 0.504 3.36295 1.125V1.4715H1.30495C0.829453 1.4715 0.439453 1.8615 0.439453 2.337C0.439453 2.8125 0.829453 3.2025 1.30495 3.2025Z"
              fill={cor}
            />
            <path
              d="M14.574 11.7977H12.516V11.4512C12.516 10.8302 12.012 10.3262 11.391 10.3262C10.77 10.3262 10.266 10.8302 10.266 11.4512V11.7977H1.30495C0.829453 11.7977 0.439453 12.1877 0.439453 12.6632C0.439453 13.1387 0.829453 13.5287 1.30495 13.5287H10.266V13.8752C10.266 14.4962 10.77 15.0002 11.391 15.0002C12.012 15.0002 12.516 14.4962 12.516 13.8752V13.5287H14.574C15.0495 13.5287 15.4395 13.1387 15.4395 12.6632C15.4395 12.1877 15.0495 11.7977 14.574 11.7977Z"
              fill={cor}
            />
            <path
              d="M14.574 6.63459H9.06445V6.28809C9.06445 5.66709 8.56045 5.16309 7.93945 5.16309C7.31845 5.16309 6.81445 5.66709 6.81445 6.28809V6.63459H1.30495C0.829453 6.63459 0.439453 7.02459 0.439453 7.50009C0.439453 7.97559 0.829453 8.36559 1.30495 8.36559H6.81445V8.71209C6.81445 9.33309 7.31845 9.83709 7.93945 9.83709C8.56045 9.83709 9.06445 9.33309 9.06445 8.71209V8.36559H14.574C15.0495 8.36559 15.4395 7.97559 15.4395 7.50009C15.4395 7.02459 15.0495 6.63459 14.574 6.63459Z"
              fill={cor}
            />
          </svg>
        );
      case "order_small":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="15"
            viewBox="0 0 16 15"
            fill="none"
            onClick={action}
          >
            <path
              d="M4.57777 14.8264L7.5915 11.813C7.96203 11.4425 7.69951 10.8096 7.17597 10.8096H5.27083V0.960968C5.27083 0.44349 4.84779 0.0205078 4.33025 0.0205078H3.99573C3.47819 0.0205078 3.05516 0.44349 3.05516 0.960968V10.8111H1.15001C0.62647 10.8111 0.36395 11.444 0.734478 11.8145L3.74821 14.8279C3.97773 15.0574 4.34976 15.0574 4.57927 14.8279L4.57777 14.8264Z"
              fill={cor}
            />
            <path
              d="M10.8511 14.039C10.8511 14.5565 11.2741 14.9795 11.7917 14.9795H12.1262C12.6437 14.9795 13.0668 14.5565 13.0668 14.039V4.18895H14.9719C15.4954 4.18895 15.758 3.55598 15.3874 3.18549L12.3737 0.172118C12.1442 -0.0573726 11.7722 -0.0573726 11.5426 0.172118L8.52891 3.18549C8.15838 3.55598 8.4209 4.18895 8.94444 4.18895H10.8496V14.039H10.8511Z"
              fill={cor}
            />
          </svg>
        );

      case "exit":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="24"
            viewBox="0 0 31 24"
            fill="none"
            onClick={action}
          >
            <path
              d="M29.4811 12.1101C29.2278 12.4032 28.9972 12.7155 28.7185 12.9841C25.4882 16.1099 22.2498 19.228 19.0141 22.3486C18.9194 22.4398 18.8261 22.5311 18.7301 22.6198C18.3395 22.9732 17.8929 23.1017 17.3863 22.8922C16.885 22.6853 16.649 22.2997 16.649 21.7766C16.649 20.2767 16.6477 18.7781 16.6463 17.2782C16.6463 17.0469 16.6463 16.8142 16.6463 16.4955H15.8784C13.3906 16.4955 10.9015 16.4968 8.41376 16.4955C7.2672 16.4955 6.82725 16.088 6.82458 15.002C6.81791 12.8595 6.81791 10.7182 6.82458 8.57567C6.82725 7.48962 7.26587 7.08347 8.41243 7.08219C11.1215 7.07962 13.8293 7.08219 16.6103 7.08219C16.6223 6.81999 16.6423 6.5925 16.6437 6.36501C16.6463 4.88695 16.653 3.4089 16.6437 1.93084C16.6397 1.36532 16.8223 0.916764 17.3863 0.685416C17.9542 0.452783 18.4182 0.650714 18.8288 1.04529C22.2205 4.31886 25.6148 7.58858 29.0038 10.8647C29.1878 11.0421 29.3238 11.2657 29.4824 11.4675V12.1101H29.4811Z"
              fill={cor}
            />
            <path
              d="M0.483755 4.65411C0.75173 3.33928 1.31701 2.18511 2.39424 1.29314C3.37282 0.48085 4.48871 0.0181543 5.78592 0.011728C7.8084 0.00401637 9.82954 0.0232954 11.8507 0.000160572C12.488 -0.00755103 12.7466 0.262355 12.7386 0.84201C12.7359 1.05665 12.7493 1.27 12.7426 1.48464C12.7253 2.07715 12.4586 2.36248 11.7894 2.3522C9.9242 2.32264 8.05771 2.33806 6.19122 2.3432C4.22607 2.34834 2.92086 3.57063 2.91419 5.46511C2.89819 9.68464 2.89553 13.9042 2.91419 18.1237C2.92353 20.0182 4.2314 21.2289 6.20322 21.234C8.02438 21.2392 9.84688 21.234 11.668 21.2353C12.576 21.2366 12.7079 21.3626 12.7426 22.2288C12.7906 23.4396 12.6666 23.5681 11.4494 23.5681C9.67223 23.5681 7.89506 23.5707 6.11789 23.5681C3.24883 23.5629 1.14369 21.8844 0.578413 19.1609C0.561081 19.0787 0.514419 19.0028 0.482422 18.9231C0.482422 14.1664 0.482422 9.41088 0.482422 4.65411H0.483755Z"
              fill={cor}
            />
          </svg>
        );

      case "exit_small":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 31 24"
            fill="none"
            onClick={action}
          >
            <path
              d="M29.4811 12.1101C29.2278 12.4032 28.9972 12.7155 28.7185 12.9841C25.4882 16.1099 22.2498 19.228 19.0141 22.3486C18.9194 22.4398 18.8261 22.5311 18.7301 22.6198C18.3395 22.9732 17.8929 23.1017 17.3863 22.8922C16.885 22.6853 16.649 22.2997 16.649 21.7766C16.649 20.2767 16.6477 18.7781 16.6463 17.2782C16.6463 17.0469 16.6463 16.8142 16.6463 16.4955H15.8784C13.3906 16.4955 10.9015 16.4968 8.41376 16.4955C7.2672 16.4955 6.82725 16.088 6.82458 15.002C6.81791 12.8595 6.81791 10.7182 6.82458 8.57567C6.82725 7.48962 7.26587 7.08347 8.41243 7.08219C11.1215 7.07962 13.8293 7.08219 16.6103 7.08219C16.6223 6.81999 16.6423 6.5925 16.6437 6.36501C16.6463 4.88695 16.653 3.4089 16.6437 1.93084C16.6397 1.36532 16.8223 0.916764 17.3863 0.685416C17.9542 0.452783 18.4182 0.650714 18.8288 1.04529C22.2205 4.31886 25.6148 7.58858 29.0038 10.8647C29.1878 11.0421 29.3238 11.2657 29.4824 11.4675V12.1101H29.4811Z"
              fill={cor}
            />
            <path
              d="M0.483755 4.65411C0.75173 3.33928 1.31701 2.18511 2.39424 1.29314C3.37282 0.48085 4.48871 0.0181543 5.78592 0.011728C7.8084 0.00401637 9.82954 0.0232954 11.8507 0.000160572C12.488 -0.00755103 12.7466 0.262355 12.7386 0.84201C12.7359 1.05665 12.7493 1.27 12.7426 1.48464C12.7253 2.07715 12.4586 2.36248 11.7894 2.3522C9.9242 2.32264 8.05771 2.33806 6.19122 2.3432C4.22607 2.34834 2.92086 3.57063 2.91419 5.46511C2.89819 9.68464 2.89553 13.9042 2.91419 18.1237C2.92353 20.0182 4.2314 21.2289 6.20322 21.234C8.02438 21.2392 9.84688 21.234 11.668 21.2353C12.576 21.2366 12.7079 21.3626 12.7426 22.2288C12.7906 23.4396 12.6666 23.5681 11.4494 23.5681C9.67223 23.5681 7.89506 23.5707 6.11789 23.5681C3.24883 23.5629 1.14369 21.8844 0.578413 19.1609C0.561081 19.0787 0.514419 19.0028 0.482422 18.9231C0.482422 14.1664 0.482422 9.41088 0.482422 4.65411H0.483755Z"
              fill={cor}
            />
          </svg>
        );

      case "pen":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="18"
            viewBox="0 0 17 18"
            fill="none"
            onClick={action}
          >
            <path
              d="M12.0951 1.37122L10.5008 2.96551L14.7848 7.24958L16.3791 5.65525C17.2016 4.83282 17.2016 3.49807 16.3791 2.67227L15.0815 1.37122C14.259 0.548787 12.9243 0.548787 12.0985 1.37122H12.0951ZM9.7559 3.71044L2.07427 11.3954C1.73047 11.7392 1.48105 12.1639 1.34286 12.6291L0.176618 16.5929C0.0957231 16.8727 0.169875 17.1726 0.375483 17.3782C0.58109 17.5838 0.881076 17.658 1.15747 17.5805L5.12131 16.4143C5.58645 16.2761 6.01115 16.0266 6.35495 15.6828L14.0433 7.99785L9.75927 3.71382L9.7559 3.71044Z"
              fill={cor}
            />
          </svg>
        );

      case "plane":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 25 21"
            fill="none"
            onClick={action}
          >
            <path
              d="M13.4065 16.494C12.0358 17.5184 11.0468 18.9055 9.43313 19.9127C9.5835 17.8005 9.69339 15.9645 9.8669 14.14C9.89582 13.8638 10.1966 13.576 10.4337 13.363C13.6668 10.4335 16.9056 7.5098 20.1444 4.58606C20.3584 4.39038 20.5493 4.17743 20.7517 3.97023C20.6997 3.87815 20.6418 3.79182 20.5898 3.69973C20.1676 3.8839 19.7165 4.02203 19.329 4.26376C15.3382 6.74434 11.3533 9.23067 7.38572 11.7515C6.77844 12.1371 6.26369 12.2005 5.59279 11.976C4.16423 11.4868 2.69518 11.1127 1.2724 10.6062C0.798143 10.4393 0.422206 10.0134 0 9.70261C0.404855 9.35729 0.751874 8.87383 1.22035 8.6839C4.26255 7.46952 7.32788 6.31844 10.3816 5.14434C14.5343 3.55585 18.6928 1.9616 22.8512 0.373111C23.4411 0.148651 24.1756 -0.306026 24.621 0.309802C24.9564 0.775989 25.0721 1.57599 24.9564 2.1688C24.2798 5.61052 23.5105 9.03498 22.7702 12.4652C22.296 14.6695 21.8217 16.8738 21.3474 19.0782C21.307 19.2681 21.2665 19.458 21.2144 19.6479C20.8385 21.1098 20.0924 21.3803 18.8431 20.4882C17.75 19.7055 16.6743 18.9055 15.5927 18.1112C14.8698 17.5817 14.1526 17.0523 13.3891 16.494H13.4065Z"
              fill={cor}
            />
          </svg>
        );

      case "add":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            onClick={action}
          >
            <rect
              x="6.5"
              y="11.3037"
              width="1"
              height="11"
              rx="0.5"
              transform="rotate(-180 6.5 11.3037)"
              fill={cor}
            />
            <rect
              x="0.5"
              y="6.30371"
              width="1"
              height="11"
              rx="0.5"
              transform="rotate(-90 0.5 6.30371)"
              fill={cor}
            />
          </svg>
        );

      case "minus":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            onClick={action}
          >
            <rect
              x="0.5"
              y="6.30371"
              width="1"
              height="11"
              rx="0.5"
              transform="rotate(-90 0.5 6.30371)"
              fill={cor}
            />
          </svg>
        );

      default:
        return null;
    }
  };

  return renderIcon();
};

export default IconesNovos;
